import { Outlet } from "react-router-dom";
import style from "./authLayout.module.scss";
import theme from "assets/themes";
const AuthLayout = () => {
  return (
    <div className={style.auth_wrapper}>
      <div
        className={style.left_panel}
        style={{ backgroundImage: `url(${theme["bg-auth"]})` }}
      >
        <div className={style.text}>
          <h1>
            High-quality leads.
            <br />
            Real results.
          </h1>
        </div>
      </div>
      <div className={style.right_panel}>
        <img src={theme["logo"]} alt="Logo" className={style.logo_top} />
        <Outlet />
      </div>
    </div>
  );
};

export default AuthLayout;
